module.exports = __webpack_public_path__ + "img/service-provider.9d3bb218.png";